import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import About from "../assets/img/About-img.png";
import shape1 from "../assets/img/about-shape-1.png";
import circleShape from "../assets/img/about-circle-shape.png";
import aboutMain from "../assets/img/about-img-1.jpg";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            About Us
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">About Us</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* About Start */}
      <div className="about-style-two-area p-50">
      <div className="container">
          <div className="row">
            <div className="col-lg-6 about-style-two">
              <div
                className="about-two-thumb"
                style={{ width: "100%", height: "auto", overflow: "hidden" }}
              >
                <img
                  src={About}
                  alt="About Epic-X Organization"
                  style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 about-style-two pl-md-15 pl-xs-15 mt-60 mt-xs-40">
              <div className="about-two-info">
                <h4 className="sub-title">About our company</h4>
                <p className="font-size-p">
                  Founded in 2023, Epic-X is a technology-driven company based
                  in Coimbatore, Tamil Nadu, specializing in AI-powered
                  applications that enhance automation, optimize workflows, and
                  drive intelligent decision-making.
                </p>
                <p className="font-size-p">
                  We also excel in mobile and web application development,
                  creating scalable, high-performance solutions tailored to
                  various industries.
                </p>
                <p className="font-size-p">
                  Our expertise spans custom software development, cloud
                  solutions, and digital transformation, ensuring seamless user
                  experiences and operational efficiency.
                </p>
                <p className="font-size-p">
                  In addition, we provide end-to-end e-commerce development,
                  delivering robust platforms that enhance user engagement,
                  boost sales, and support business growth. Our team of skilled
                  professionals, developers, and digital strategists is
                  committed to helping businesses innovate and scale effectively
                  in a competitive digital landscape.
                </p>
              </div>
            </div>
            </div>
          </div>
      </div>

      <div className="bg-white tp-about-area ab-area-sapce">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xl-5 col-lg-5 order-2 order-lg-1 wow tpfadeLeft"
              data-wow-duration=".7s"
              data-wow-delay=".5s"
            >
              <div className="tp-ab-wrapper p-relative" style={{ width: "100%", height: "auto", overflow: "hidden" }}>
                <div className="tp-ab-shape-one z-index-3">
                  <img src={shape1} alt="" style={{ width: "100%", height: "auto", objectFit: "cover" }}/>
                </div>
                <div className="tp-ab-shape-two z-index-3">
                  <img src={circleShape} alt="" style={{ width: "100%", height: "auto", objectFit: "cover" }}/>
                </div>
                <div className="tp-about-thumb">
                  <img src={aboutMain} alt="" style={{ width: "100%", height: "auto", objectFit: "cover" }}/>
                </div>
              </div>
            </div>
            <div
              className="col-xl-7 col-lg-7 order-1 order-lg-2 wow tpfadeRight"
              data-wow-duration=".7s"
              data-wow-delay=".7s"
            >
              <div>
                <h4 className="tp-section-subtitle tp-green-color">
                  Who we are?
                </h4>
                <h3 className="tp-section-title">
                  We are dynamic team of creative design and development
                </h3>
                <p className="font-size-p">
                  We have almost 2+ years of experience for helping consulting
                  services <br /> and business solutions and best protect.
                </p>
                <p className="font-size-p">
                  We are a team of performance-driven entrepreneurs with a
                  passionate commitment to building innovative products and
                  providing state-of-the-art digital solutions that empower
                  businesses to thrive in the online marketplace.
                </p>
                <a className="tp-btn" href="#">
                  About our Agency
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
      <Footer />
    </div>
  );
};

export default AboutUs;
